"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types2D = void 0;
exports.Types2D = {
    screenContainer: "2d.screencontainer",
    overlay: "2d.overlay",
    finger: "2d.finger",
    preloadAssetsAction: "2d.preload",
    screenShotAction: "2d.screenshot",
    spriteRenderer: "2d.spriteRenderer",
    rootView: "2d.rootView",
    spinner: "2d.spinner",
    blackSquareGraphics: "2d.blackSquareGraphics",
    whiteSquareGraphics: "2d.whiteSquareGraphics",
    userPic: "2d.userPic",
    circleAvatar: "2d.circleAvatar"
};
//# sourceMappingURL=Types2D.js.map